require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/toast/style", "vant/es/toast", "vant/es/collapse-item/style", "vant/es/collapse-item", "vant/es/collapse/style", "vant/es/collapse", "vant/es/loading/style", "vant/es/loading", "vant/es/icon/style", "vant/es/icon", "@/utils/time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/toast/style"), require("vant/es/toast"), require("vant/es/collapse-item/style"), require("vant/es/collapse-item"), require("vant/es/collapse/style"), require("vant/es/collapse"), require("vant/es/loading/style"), require("vant/es/loading"), require("vant/es/icon/style"), require("vant/es/icon"), require("@/utils/time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.toast, global.style, global.collapseItem, global.style, global.collapse, global.style, global.loading, global.style, global.icon, global.time);
    global.checkInfo = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _toast, _style2, _collapseItem, _style3, _collapse, _style4, _loading, _style5, _icon, _time) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toast = _interopRequireDefault(_toast);
  _collapseItem = _interopRequireDefault(_collapseItem);
  _collapse = _interopRequireDefault(_collapse);
  _loading = _interopRequireDefault(_loading);
  _icon = _interopRequireDefault(_icon);
  var TIMEOUT_SECONDS = 180;
  var _default = {
    name: "CheckInfo",
    components: {
      Icon: _icon.default,
      Loading: _loading.default,
      Collapse: _collapse.default,
      CollapseItem: _collapseItem.default
    },
    data: function data() {
      var ossHost = this.$config.base.ossHost; // 是否需要切换至新版质检逻辑

      return {
        ossHost: ossHost,
        signalPass: false,
        motorPass: false,
        uniqueId: "-",
        signal: "-",
        warningList: [// {text: '数据有效', pass: true},
        // {text: '设备角度正常，正常泵气', pass: true},
        {
          text: '正常读取探头数据',
          pass: false
        } // {text: '探头稳定', pass: true},
        // {text: '算法在规定时间内给出目标值', pass: true}
        ],
        errorStatus: true,
        imgUrl: 'img/goods-ryy.png',
        sensorPass: false,
        // null表示尚未完成重复校验，true表示重复探头，false表示新探头
        factoryDuplicate: null,
        // 重复探头时，是否按返修主机处理（打开后忽略重复校验）
        isRepairHost: false,
        sensorErrText: '',
        deviceName: '',
        sensorId: '',
        adErrText: '',
        // 气泵状态：0是开启，1是关闭
        pumpStatus: 0,
        updatePumpStatusLoading: false,
        // 气路自检状态：0未开始自检，1点击下发自检命令，2下发成功等待自检结果
        pumpCheckStatus: 0,
        pumpPass: false,
        pumpCheckErrorText: '',
        // 获取质检状态
        loadingData: false,
        // 气路自检loading状态
        pumpLoad: true,
        // 是否不支持气路检测
        notPumpCheck: false,
        themeColor: '#209A56',
        // 溶氧类型
        // 3,4 电解法溶氧仪、5-16 荧光法溶氧仪，17是小方帽
        ryType: 14,
        // 小方帽饱和氧合格状态
        fullOxyPass: false,
        // 小方帽零氧合格状态
        zeroOxyPass: false,
        // 运动传感器角度检测是否正常，放在特定治具上检测15°倾角
        anglePass: false,
        // 是否经常硬件复位
        hasHardwareResetError: false,
        activeNames: "1",
        isRyBaseVersion: false,
        // 非小红帽需要两不检测，在一周的时间范围内
        // 0表示未完成任何一步检测，1表示完成探头AD曲线，2表示盖盖子后完成气路检测
        passType: 0,
        qaProbePass: false,
        qaPumpPass: false,
        pumpBtnText: '开始自检'
      };
    },
    created: function created() {
      var vm = this;
      vm.fullCount = 0;
      vm.xfmRefreshCount = 0;
      vm.$route.query.uuid ? vm.loadDeviceInfo() : vm.$router.replace({
        path: "/factory/index"
      });
    },
    destroyed: function destroyed() {
      // 清除定时器
      this.loadCheckIntervalId && clearInterval(this.loadCheckIntervalId);
      this.intervalId && clearInterval(this.intervalId);
    },
    computed: {
      // 重复探头且未声明为返修主机时，拦截后续检测与提交
      isDuplicateSensorBlocked: function isDuplicateSensorBlocked() {
        return this.factoryDuplicate === true && !this.isRepairHost;
      }
    },
    watch: {
      isRepairHost: function isRepairHost() {
        this.updateDeviceQAProgress();
      }
    },
    methods: {
      passAction: function passAction() {
        var vm = this;
        var sensorId = vm.sensorId; // 是否为小方帽，小方帽质检的规则不一样

        if (vm.isRyBaseVersion) {
          if (!(vm.signalPass && vm.fullOxyPass && vm.zeroOxyPass && !vm.hasHardwareResetError)) {
            return;
          }
        } else {
          // 第一步主机探头等的检测
          if (!(vm.signalPass && vm.motorPass && !vm.errorStatus && vm.sensorPass && !vm.isDuplicateSensorBlocked && vm.anglePass && !vm.hasHardwareResetError) && vm.activeNames == 1) {
            return;
          }

          if (!(vm.pumpPass && !vm.isDuplicateSensorBlocked && !vm.hasHardwareResetError) && vm.activeNames == 2) {
            return;
          }
        }

        var USER_NAME = vm.$config.keys.USER_NAME;
        var name = vm.$localStorage.getItem(USER_NAME);

        var tt = _toast.default.loading({
          message: "加载中...",
          forbidClick: true,
          overlay: true,
          duration: 0
        });

        if (vm.activeNames == 2 || vm.isRyBaseVersion) {
          sensorId = vm.sensorId || '20230001';
        }

        vm.$http({
          method: "post",
          except: true,
          url: "".concat(vm.$config.base.BASE_URL, "admin/iotTool/product/device/").concat(vm.uniqueId, "/pass"),
          data: {
            name: name,
            signal: vm.signal > 100 ? vm.signal - 100 : vm.signal,
            // 如果是第二步齐鲁质检，允许没sersorId并且自动填充默认值，如果是第一步，需要传sensorId
            sensorId: sensorId,
            v: 2,
            status: Number(vm.activeNames)
          }
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;
          tt.clear();

          if (code == 1) {
            _toast.default.success({
              message: data || "已成功通过质检~",
              forbidClick: true,
              overlay: true,
              duration: 3000,
              onClose: function onClose() {
                vm.$router.replace({
                  path: "/factory/index"
                });
              }
            });
          } else {
            _toast.default.fail({
              message: message,
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          }
        }).catch(function (err) {
          console.log(err);
          tt.clear();

          _toast.default.fail({
            message: JSON.stringify(err),
            forbidClick: true,
            overlay: true,
            duration: 3000
          });
        });
      },
      // 打开溶氧仪气泵
      onclickUpdatePumpBtn: function onclickUpdatePumpBtn() {
        var vm = this;
        var _vm$$config$base = vm.$config.base,
            ADMIN_URL = _vm$$config$base.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base.ADMIN_TOKEN;
        vm.updatePumpStatusLoading = true;
        vm.$http({
          type: "PUT",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/devices/register/config/").concat(vm.deviceId),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true,
          data: {
            stopPump: 0
          }
        }).then(function (res) {
          var code = res.code,
              message = res.message;
          vm.updatePumpStatusLoading = false;

          if (code == 1) {
            vm.pumpStatus = 0;

            _toast.default.success({
              message: '已成功开启气泵',
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          } else {
            _toast.default.fail({
              message: message,
              forbidClick: true,
              overlay: true,
              duration: 3000
            });

            vm.loadDeviceConfig(vm.deviceId);
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 重新检测
      onClickShowStartCheckModalBtn: function onClickShowStartCheckModalBtn() {
        var vm = this;
        var _vm$$config$base2 = vm.$config.base,
            ADMIN_URL = _vm$$config$base2.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base2.ADMIN_TOKEN;
        vm.pumpLoad = true;
        vm.pumpCheckErrorText = '';
        vm.pumpBtnText = '指令下发中...';
        vm.$http({
          type: "put",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/").concat(vm.ryDeviceId, "/originCommand"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true,
          data: {
            airChanelCheckRequest: {
              motorHz: 0,
              motorRatio: 0
            },
            status: 1,
            ttCheckDurationMs: 300,
            maxAngle: 30
          }
        }).then(function (res) {
          var code = res.code,
              message = res.message; // 自检指令下发成功

          if (code == 1) {
            vm.startTime = new Date().getTime();
            vm.loadCheckIntervalId = setInterval(vm.loadRyCheckStatus, 10000);
            vm.pumpBtnText = '气路自检中...';
          } else {
            _toast.default.fail({
              message: message || '自检指令下发超时，请重试',
              forbidClick: true,
              overlay: true,
              duration: 4000
            });

            vm.pumpLoad = false;
            vm.pumpBtnText = '开始自检';
          }
        });
      },
      // 获取气路自检结果列表
      loadRyCheckStatus: function loadRyCheckStatus() {
        var vm = this;
        var _vm$$config$base3 = vm.$config.base,
            ADMIN_URL = _vm$$config$base3.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base3.ADMIN_TOKEN; // 如果是九耳的新主机

        if (vm.ryType > 17) {
          vm.loadJiuErCheckStatus();
          return;
        }

        vm.$http({
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/").concat(vm.ryDeviceId, "/airChannelCheckRecords"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;

          if (code == 1 && data.length) {
            // 重新排序
            var listArr = data.sort(function (a, b) {
              return b.createAt - a.createAt;
            }); // 有有效结果更改页面显示状态，只认最近一小时内的检测结果

            if (Math.abs(new Date(listArr[0].createAt).getTime() - vm.startTime) < 3600 * 1000) {
              var _listArr$ = listArr[0],
                  inletValveWarn = _listArr$.inletValveWarn,
                  outValveWarn = _listArr$.outValveWarn,
                  pumpWarn = _listArr$.pumpWarn;
              clearInterval(vm.loadCheckIntervalId);
              vm.ttid && vm.ttid.clear(); // vm.pumpPass = inWater != 1 && !inletValveWarn && !outValveWarn && !pumpWarn
              // if (!vm.pumpPass) {

              var errArr = []; //     inWater == 1 && (errArr.push('进水'));

              inletValveWarn && errArr.push('充气阀异常');
              outValveWarn && errArr.push('排气阀异常');
              pumpWarn && errArr.push('气泵异常');
              errArr.length && (vm.pumpCheckErrorText = errArr.join(',')); // }

              vm.pumpPass = !inletValveWarn && !outValveWarn && !pumpWarn;
              vm.pumpLoad = false;
              vm.pumpBtnText = '开始自检';
            } else {
              // 三分钟还未获取到数据算超时
              console.log(new Date().getTime() - vm.startTime);

              if (new Date().getTime() - vm.startTime > 1000 * TIMEOUT_SECONDS || !vm.loadCheckIntervalId) {
                vm.ttid && vm.ttid.clear();
                vm.loadCheckIntervalId && _toast.default.fail({
                  message: message || '检测超时，请重试',
                  forbidClick: true,
                  overlay: true,
                  duration: 4000
                });
                vm.pumpLoad = false;
                vm.loadCheckIntervalId && (vm.pumpCheckErrorText = '检测超时，请重试');
                clearInterval(vm.loadCheckIntervalId);
                vm.pumpBtnText = '开始自检';
              }
            }
          } else {
            // 三分钟还未获取到数据算超时
            if (new Date().getTime() - vm.startTime > 1000 * TIMEOUT_SECONDS || !vm.loadCheckIntervalId) {
              vm.ttid && vm.ttid.clear();
              vm.loadCheckIntervalId && _toast.default.fail({
                message: message || '检测超时，请重试',
                forbidClick: true,
                overlay: true,
                duration: 4000
              });
              vm.pumpLoad = false;
              vm.loadCheckIntervalId && (vm.pumpCheckErrorText = '检测超时，请重试');
              clearInterval(vm.loadCheckIntervalId);
            }
          }
        }).catch(function (err) {
          vm.ttid && vm.ttid.clear();
          vm.pumpLoad = false;

          _toast.default.fail({
            message: err.message || '请求失败，请重试',
            forbidClick: true,
            overlay: true,
            duration: 4000
          });

          vm.pumpCheckErrorText = '请求失败，请重试';
        });
      },
      // 获取九耳主机气路检测结果
      loadJiuErCheckStatus: function loadJiuErCheckStatus() {
        var vm = this;
        var _vm$$config$base4 = vm.$config.base,
            ADMIN_URL = _vm$$config$base4.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base4.ADMIN_TOKEN;
        vm.$http({
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/").concat(vm.ryDeviceId, "/airCheckDays"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;

          if (code == 1 && data.checkResultViews && data.checkResultViews.length) {
            // 重新排序
            var listArr = data.checkResultViews; // 有有效结果更改页面显示状态，只认5分钟内的结果

            if (Math.abs(new Date(listArr[0].createAt).getTime() - vm.startTime) < 3600 * 1000) {
              var _listArr$2 = listArr[0],
                  status = _listArr$2.status,
                  closePressList = _listArr$2.closePressList;
              clearInterval(vm.loadCheckIntervalId);
              vm.ttid && vm.ttid.clear(); // 质检通过并且水泵压力大于90kPa

              vm.pumpPass = !(status > 2 && status < 7) && closePressList[5] > 90000;

              if (!vm.pumpPass) {
                var errArr = [];
                status == 3 && errArr.push('气压计异常');
                status == 6 && errArr.push('充气阀异常');
                status == 5 && errArr.push('排气阀异常');
                (status == 4 || closePressList[5] < 90000) && errArr.push('气泵异常'); // status == 7 && (errArr.push('未放入水中'))

                closePressList[5] <= 9000 && errArr.push("\u6C14\u6CF5\u6C14\u538B\u592A\u4F4E".concat((closePressList[5] / 1000).toFixed(1), "Kpa"));
                errArr.length && (vm.pumpCheckErrorText = errArr.join(','));
              }

              console.log(vm.pumpCheckErrorText);
              vm.pumpLoad = false;
              vm.pumpBtnText = '开始自检';
            } else {
              // 三分钟还未获取到数据算超时
              console.log(new Date().getTime() - vm.startTime);

              if (new Date().getTime() - vm.startTime > 1000 * TIMEOUT_SECONDS || !vm.loadCheckIntervalId) {
                vm.ttid && vm.ttid.clear();
                vm.loadCheckIntervalId && _toast.default.fail({
                  message: message || '检测超时，请重试',
                  forbidClick: true,
                  overlay: true,
                  duration: 4000
                });
                vm.pumpLoad = false;
                vm.loadCheckIntervalId && (vm.pumpCheckErrorText = '检测超时，请重试');
                clearInterval(vm.loadCheckIntervalId);
                vm.pumpBtnText = '开始自检';
              }
            }
          } else {
            // 三分钟还未获取到数据算超时
            if (new Date().getTime() - vm.startTime > 1000 * TIMEOUT_SECONDS || !vm.loadCheckIntervalId) {
              vm.ttid && vm.ttid.clear();
              vm.loadCheckIntervalId && _toast.default.fail({
                message: message || '检测超时，请重试',
                forbidClick: true,
                overlay: true,
                duration: 4000
              });
              vm.pumpLoad = false;
              vm.loadCheckIntervalId && (vm.pumpCheckErrorText = '检测超时，请重试');
              clearInterval(vm.loadCheckIntervalId);
              vm.pumpBtnText = '开始自检';
            }
          }
        }).catch(function (err) {
          vm.ttid && vm.ttid.clear();
          vm.pumpLoad = false;

          _toast.default.fail({
            message: err.message || '请求失败，请重试',
            forbidClick: true,
            overlay: true,
            duration: 4000
          });

          vm.pumpCheckErrorText = '请求失败，请重试';
          vm.pumpBtnText = '开始自检';
        });
      },
      // 获取设备配置
      loadDeviceConfig: function loadDeviceConfig(deviceId) {
        var vm = this;
        var _vm$$config$base5 = vm.$config.base,
            ADMIN_URL = _vm$$config$base5.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base5.ADMIN_TOKEN;
        vm.$http({
          type: "get",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/devices/register/config/").concat(deviceId),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;
          vm.ttid && vm.ttid.clear();
          vm.ttid = "";

          if (code == 1) {
            vm.ryDeviceId = data.deviceId;

            if (data && data.configFields) {
              vm.pumpStatus = data.configFields[22].value;
            } // 如果新版质检流程刚进来的时候获取该设备的质检结果


            vm.startTime = new Date().getTime();
            vm.loadRyCheckStatus();
          } else {
            _toast.default.loading({
              message: message,
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          }
        });
      },
      // 获取当前倾斜角度
      loadDeviceAngle: function loadDeviceAngle(deviceId) {
        var vm = this;
        var _vm$$config$base6 = vm.$config.base,
            ADMIN_URL = _vm$$config$base6.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base6.ADMIN_TOKEN; // 一小时内的数据

        var sTime = (0, _time.turnTime)(new Date().getTime() - 3600 * 1000).split('/').join('-');
        var eTime = (0, _time.turnTime)(new Date().getTime()).split('/').join('-');
        vm.$http({
          type: "get",
          url: "".concat(ADMIN_URL, "javaApi/iot/ryAngleAndSignalRecords?deviceId=").concat(deviceId, "&startTime=").concat(sTime, "&endTime=").concat(eTime),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data;

          if (code == 1 && data.length) {
            if (data[data.length - 1].angle < 25 && data[data.length - 1].angle > 5) {
              vm.anglePass = true;
            }
          } else {// Toast.loading({
            //     message,
            //     forbidClick: true,
            //     overlay: true,
            //     duration: 3000
            // });
          }
        });
      },
      // 获取AD曲线
      loadAdLine: function loadAdLine(deviceId) {
        var vm = this;
        var _vm$$config$base7 = vm.$config.base,
            ADMIN_URL = _vm$$config$base7.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base7.ADMIN_TOKEN,
            oxygenValList = _vm$$config$base7.oxygenValList;
        var errObj = {
          "ERR_NONE": "正常",
          "ERR_PIPE_LEAKAGE": "管道漏气",
          "ERR_NOT_CLASSIFIED": "未分类",
          "ERR_SENSOR_BROKEN": "探头严重破损",
          "ERR_SENSOR_POLLUTED": "探头污染",
          "ERR_MINOR_LEAKAGE": "探头轻微破损",
          "ERR_UNKNOWN_ERROR": "未知类型异常",
          "ERR_FLAT_IN_AIR": "探头未接触水面",
          "ERR_FLAT_IN_WATER": "探头泡水"
        }; // const year = new Date().getUTCFullYear();
        // const month = new Date().getMonth() + 1 > 9 ? new Date().getMonth() + 1 : `0${new Date().getMonth() + 1}`;
        // const days = new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`;

        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1 > 9 ? new Date().getMonth() + 1 : "0".concat(new Date().getMonth() + 1);
        var date = new Date().getDate() > 9 ? new Date().getDate() : "0".concat(new Date().getDate());
        vm.$http({
          type: "get",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/").concat(deviceId, "/adSampleList/").concat(year).concat(month).concat(date),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;
          vm.ttid && vm.ttid.clear();
          vm.ttid = "";

          if (code == 1) {
            // data = [{"_id":"62a6fd1fa0b7024203d541ef","device_id":"1104589390","data_index":1,"oxygen":0.0,"last_oxygen":7.4,"voltage":0.1,"last_voltage":74.6,"temperature":0,"last_temperature":295,"start_time":1010,"test_time":72,"spacing_time":5,"type":2,"data_count":132,"data_group":"[748, 748, 731, 714, 617, 523, 436, 356, 319, 283, 219, 163, 86, 50, 15, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 70, 146, 172, 199, 258, 325, 401, 443, 485, 577, 677, 699, 705, 711, 719, 725, 731, 734, 735, 737, 740, 741, 743, 743, 743, 744, 745, 745, 745, 745, 745, 745, 746, 746, 746, 747, 746, 746, 746, 746, 747, 747, 747, 747, 746, 746, 746, 746, 746, 746, 746, 746, 746, 746, 746, 746, 746]","create_time":"2022-06-13 17:02:23","errorCode":"ERR_NONE","sensorId":"22060384","device_error":"ERR_NONE","measured_o2":0.0,"measured_ad":1,"final_o2":0.0,"saturated_AD":749,"zero_AD":0,"calib_temperature":29.0,"sensor_broken":0,"sensor_broken_ad":0,"calibType":12}]
            if (data && data.length) {
              var sensorErrText = '';
              var arr = data.sort(function (a, b) {
                return new Date(b.create_time.split(' ').join('T')).getTime() - new Date(a.create_time.split(' ').join('T')).getTime();
              });
              var adList = JSON.parse(arr[0].data_group) || [];
              var fullOxy = 0;
              var tmp = parseInt((arr[0].temperature || arr[0].last_temperature) / 10); // 零氧点取6分钟的点，低于0.2

              var zeroOxy = adList[72];

              if (arr[0] && new Date().getTime() - new Date(arr[0].create_time.split(' ').join('T')).getTime() < 3600 * 1000) {
                if (arr[0] && ['ERR_NONE', 'ERR_SENSOR_POLLUTED'].includes(arr[0].errorCode)) {
                  vm.motorPass = true;
                } else {
                  if (arr[0]) {
                    var time = new Date().getTime() - new Date(arr[0].create_time.split(' ').join('T')).getTime();
                    vm.adErrText = errObj[arr[0].errorCode];
                    vm.adErrText += "(".concat((16 - time / 60000).toFixed(1), "\u5206\u949F\u540E\u518D\u8BD5)");
                  }
                } // 饱和氧用当前AD曲线前后点的最大值


                if (adList[0] || adList[adList.length - 1]) {
                  fullOxy = adList[adList.length - 1] > adList[0] ? adList[adList.length - 1] : adList[0];
                } // 探头饱和氧偏差值


                var fullOxyVg = (fullOxy / 100 - oxygenValList[tmp]) / oxygenValList[tmp]; // 饱和氧取点，第一个、最后一个或者后台给的满足条件就行

                vm.sensorPass = fullOxyVg <= 0.1 && fullOxyVg > -0.3 && zeroOxy <= 20;
                console.log(fullOxyVg);
                console.log(zeroOxy);

                if (!vm.sensorPass) {
                  !(fullOxyVg <= 0.1 && fullOxyVg > -0.3) && (sensorErrText = '饱和氧偏差过大');
                  zeroOxy > 50 && (sensorErrText = sensorErrText ? '饱和氧跟收敛时间都不合格' : '收敛时间不合格');
                  vm.sensorErrText = sensorErrText;
                }

                vm.sensorId = arr[0].sensorId;
                vm.loadSensorDuplicateCheck(vm.sensorId);
              }
            }
          } else {
            _toast.default.loading({
              message: message,
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          }
        }).catch(function (err) {
          console.log(err);
          vm.ttid && vm.ttid.clear();
          vm.ttid = "";
        });
      },
      // 校验探头是否在出厂场景中重复使用
      loadSensorDuplicateCheck: function loadSensorDuplicateCheck(sensorId) {
        var vm = this;
        var _vm$$config$base8 = vm.$config.base,
            ADMIN_URL = _vm$$config$base8.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base8.ADMIN_TOKEN;
        vm.factoryDuplicate = null;
        vm.isRepairHost = false;
        vm.$http({
          type: "get",
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/sensorDuplicateCheck"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true,
          params: {
            sensorId: sensorId
          }
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;

          if (code == 1 && data) {
            vm.factoryDuplicate = data.factoryDuplicate;
            vm.updateDeviceQAProgress();
          } else {
            _toast.default.fail({
              message: message || '探头重复校验失败，请重试',
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          }
        }).catch(function (err) {
          console.log(err);

          _toast.default.fail({
            message: '探头重复校验失败，请重试',
            forbidClick: true,
            overlay: true,
            duration: 3000
          });
        });
      },
      // 只有确认不是重复探头后，才恢复已有的质检进度
      updateDeviceQAProgress: function updateDeviceQAProgress() {
        if (this.isDuplicateSensorBlocked) {
          this.passType = 0;
          this.activeNames = '1';
          return;
        }

        if (this.qaPumpPass) {
          this.passType = 2;
          this.activeNames = '3';
        } else if (this.qaProbePass) {
          this.passType = 1;
          this.activeNames = '2';
        }
      },
      // 获取设备信息
      loadDeviceInfo: function loadDeviceInfo() {
        var vm = this;
        vm.loadingData = true; // vm.ttid = Toast.loading({
        //     message: "加载中...",
        //     forbidClick: true,
        //     overlay: true,
        //     duration: 0
        // });

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.BASE_URL, "admin/iotTool/product/device/").concat(vm.$route.query.uuid),
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data,
              message = res.message;

          if (code == 1) {
            if (!data.uniqueId) {
              _toast.default.fail({
                message: "二维码错误，设备不存在~",
                forbidClick: true,
                overlay: true,
                duration: 3000,
                onClose: function onClose() {
                  vm.$router.replace({
                    path: "/factory/index"
                  });
                }
              });
            }

            vm.uniqueId = data.uniqueId;
            vm.deviceId = data.deviceId;
            vm.signal = data.list[0] ? data.list[0].signal : 0;
            vm.signal = vm.signal > 100 ? vm.signal - 100 : vm.signal;
            vm.signalPass = vm.signal > 100 ? vm.signal >= 119 : vm.signal >= 19;
            vm.deviceName = vm.$strTool.filterRyyDeviceName(data.type);
            vm.ryType = data.type;
            vm.isRyBaseVersion = vm.ryType == 17; // 小方帽出厂测试流程
            // 只测饱和氧偏差+零氧<0.3+信号

            if (vm.isRyBaseVersion) {
              vm.imgUrl = 'img/ry-xfm.png';
              vm.loadXfmOxyData(); // 小方帽需要单独获取探头ID

              vm.loadAdminDeviceInfo(vm.deviceId);
              !vm.intervalId && (vm.intervalId = setInterval(vm.loadXfmOxyData, 10000));
            } else {
              // 小红帽出厂测量流程
              vm.loadAdLine(data.deviceId);
              vm.loadDeviceAngle(data.deviceId);
              vm.loadDeviceConfig(data.deviceId);
              vm.loadDeviceQAHistory();
              data.list.sort(function (a, b) {
                return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
              });

              if (data.type > 4) {
                vm.imgUrl = 'img/goods-ygf-ryy.png';
              }

              data.list.length && vm.checkErrorCode(data.list[0].errorCode); // 关闭持续测量模式

              vm.closeKeepMeasure(vm.uniqueId);
            } // 获取设备注册历史, 排除硬件复位的故障设备流出


            vm.loadDeviceResgisterHistory();
          } else {
            vm.ttid && vm.ttid.clear();
            vm.ttid = "";

            _toast.default.loading({
              message: message,
              forbidClick: true,
              overlay: true,
              duration: 3000
            });
          }

          vm.loadingData = false;
        }).catch(function (err) {
          console.log(err);
          vm.ttid && vm.ttid.clear();
          vm.ttid = "";
          vm.loadingData = false;
        });
      },
      // 关闭溶氧持续测量模式
      closeKeepMeasure: function closeKeepMeasure(uniqueId) {
        var vm = this;
        var _vm$$config$base9 = vm.$config.base,
            ADMIN_URL = _vm$$config$base9.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base9.ADMIN_TOKEN; // 0关闭持续测量 1开启

        var status = 0;
        vm.$http({
          type: "get",
          url: "".concat(ADMIN_URL, "javaApi/iot/ry/").concat(uniqueId, "/keepMeasure/").concat(status),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then();
      },
      // code： 0表示正常，1表示有异常
      checkErrorCode: function checkErrorCode(code) {
        var vm = this; // const codeStr = vm.$strTool.dec2bin(code, 8);
        // `${codeStr}`.split('').map((c, index) => {
        //     if (index == 2) {
        //         c == '1' && (vm.errorStatus = true)
        //         c == '1' && (vm.warningList[0].pass = false);
        //     }
        // })

        if (Number(code) == 0) {
          vm.errorStatus = false;
          vm.warningList[0].pass = true;
        }
      },
      refreshSignal: function refreshSignal() {
        var vm = this;
        vm.loadDeviceInfo();
      },
      // 主动刷新小方帽数据
      loadXfmOxyData: function loadXfmOxyData() {
        var vm = this;
        vm.xfmRefreshCount++;

        if (vm.xfmRefreshCount >= 20) {
          clearInterval(vm.intervalId);
          vm.intervalId = null;
          vm.loadingData = false;
          return;
        }

        var _vm$$config$base10 = vm.$config.base,
            ADMIN_URL = _vm$$config$base10.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base10.ADMIN_TOKEN;
        vm.$http({
          type: "get",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/refreshStatus/").concat(vm.deviceId),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          console.log(res);
          vm.loadXfmUpdateLog();
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 获取小方帽上报的日志
      loadXfmUpdateLog: function loadXfmUpdateLog() {
        var vm = this;
        var _vm$$config$base11 = vm.$config.base,
            ADMIN_URL = _vm$$config$base11.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base11.ADMIN_TOKEN,
            oxygenValList = _vm$$config$base11.oxygenValList;
        vm.$http({
          type: "get",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/logs/").concat(vm.deviceId, "/v2?start=").concat(new Date().getTime() - 1200000, "&end=").concat(new Date().getTime(), "&pageNo=1&type=2"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          res.data.length && res.data.map(function (item) {
            // 上报数据check
            if (item.log.includes('数据索引:')) {
              var tmp = parseInt(Number(item.log.split('测量温度')[1].split(',')[0]));
              var fullOxy = Number(item.log.split('水中电压')[1].split(',')[0]);
              var signal = Number(item.log.split('信号强度')[1].split(',')[0]);
              var readSucc = item.log.includes('正常读取'); // 正常读取数据的情况下判断饱和氧+零氧

              if (readSucc) {
                // 探头饱和氧偏差值，至少5个溶氧点才能满足
                var fullOxyVg = (fullOxy / 100 - oxygenValList[tmp]) / oxygenValList[parseInt(tmp)];

                if (fullOxyVg <= 0.1 && fullOxyVg > -0.3) {
                  vm.fullCount++;

                  if (vm.fullCount >= 3) {
                    vm.fullOxyPass = true;
                  }
                }

                vm.signal = signal;
                vm.signalPass = signal - 100 >= 18;

                if (fullOxy <= 20 && fullOxy) {
                  vm.zeroOxyPass = true;
                }
              }
            }
          });

          if (vm.fullOxyPass && vm.zeroOxyPass) {
            vm.loadingData = false;
            clearInterval(vm.intervalId);
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      loadAdminDeviceInfo: function loadAdminDeviceInfo(deviceId) {
        var vm = this;
        var _vm$$config$base12 = vm.$config.base,
            ADMIN_URL = _vm$$config$base12.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base12.ADMIN_TOKEN;
        vm.$http({
          type: "get",
          // url: `${ADMIN_URL}javaApi/iot/factoryRyAdSample/${deviceId}`,
          url: "".concat(ADMIN_URL, "javaApi/iot/devicesManage/").concat(deviceId),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data;

          if (code == 1 && data.probeId) {
            vm.sensorId = data.probeId;
          }
        });
      },
      // 获取设备注册历史, 排除硬件复位的故障设备流出，查村近7天的记录
      loadDeviceResgisterHistory: function loadDeviceResgisterHistory() {
        var vm = this;
        var _vm$$config$base13 = vm.$config.base,
            ADMIN_URL = _vm$$config$base13.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base13.ADMIN_TOKEN;
        var endTime = new Date().getTime();
        var startTime = endTime - 24 * 60 * 60 * 1000 * 7;
        vm.$http({
          type: "get",
          url: "".concat(ADMIN_URL, "admin/device/manage/deviceRegister/").concat(vm.deviceId, "?startTime=").concat(startTime, "&endTime=").concat(endTime),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true
        }).then(function (res) {
          var code = res.code,
              data = res.data;

          if (code == 1) {
            var hasHardwareReset = data.records.filter(function (item) {
              return item.reason == 2;
            }).length >= 2;
            console.log(hasHardwareReset);
            vm.hasHardwareResetError = hasHardwareReset;
          }
        });
      },
      onChange: function onChange(activeNames) {
        this.activeNames = activeNames;
        console.log(activeNames);
      },
      // 获取设备出厂质检记录
      loadDeviceQAHistory: function loadDeviceQAHistory() {
        var vm = this;
        var _vm$$config$base14 = vm.$config.base,
            ADMIN_URL = _vm$$config$base14.ADMIN_URL,
            ADMIN_TOKEN = _vm$$config$base14.ADMIN_TOKEN;
        vm.$http({
          type: "get",
          url: "".concat(ADMIN_URL, "admin/iotTool/product/preSales/ryy"),
          headers: {
            'access-token': ADMIN_TOKEN
          },
          except: true,
          params: {
            pageNo: 1,
            pageSize: 10,
            uniqueId: vm.uniqueId,
            // 近1天的时间戳范围，修改成十位时间戳
            startAt: Math.floor(new Date().getTime() / 1000) - 24 * 60 * 60 * 3,
            endAt: Math.floor(new Date().getTime() / 1000)
          }
        }).then(function (res) {
          vm.qaProbePass = res.data.list.filter(function (item) {
            return item.status == 1;
          }).length > 0;
          vm.qaPumpPass = res.data.list.filter(function (item) {
            return item.status == 2;
          }).length > 0;
          vm.updateDeviceQAProgress();
          console.log(vm);
        });
      }
    }
  };
  _exports.default = _default;
});